import React, { Component } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';
import './UserGuideSuccess.scss';

class UserGuiderSuccess extends Component {
    state = {
        isShowToolTip: false,
        isExpanded: this.props.isMobile ? false : true
    }
    componentDidMount() {
        setTimeout(() => {
            this.setState({ isShowToolTip: true }, () => {
                setTimeout(() => {
                    this.setState({ isShowToolTip: false });
                }, (this.props.expirytime == undefined) ? 7000 : this.props.expirytime);
            });
        }, 500);
    }
    render() {
        const { target, placement, content } = this.props;
        return (
            <Overlay transition target={target}
                show={this.state.isShowToolTip} placement={placement} >
                {(props) => (
                    <Tooltip {...props} >
                        <i onClick={() => {
                            this.setState({ isShowToolTip: false });
                        }} className="fas fa-times justify-content-end d-flex cursor-pointer" />
                        <div className={this.state.isExpanded ? "" : "userguide-truncater"}>{content}</div>
                        {this.state.isExpanded ? null : <div className="user-guide-see-more" onClick={() => this.setState({ isExpanded: true })}>see more..</div>}
                    </Tooltip>
                )}

            </Overlay>
        );
    }
}

export default UserGuiderSuccess;